'use client';

import React, { useContext } from 'react';
import LogInMobile from '$modules/onboarding/module-components/onboarding/log-in/log-in.mobile';
import LogInWeb from '$modules/onboarding/module-components/onboarding/log-in/log-in.web';
import { GlobalContext } from '$context/global-context';
const Page = () => {
  const {
    state
  } = useContext(GlobalContext);
  const isMobile = state.screen.isMobile;
  return isMobile ? <LogInMobile data-sentry-element="LogInMobile" data-sentry-component="Page" data-sentry-source-file="page.tsx" /> : <LogInWeb data-sentry-element="LogInWeb" data-sentry-component="Page" data-sentry-source-file="page.tsx" />;
};
export default Page;